<h2 mat-dialog-title>{{title}}</h2>

<div mat-dialog-content>

    <div fxLayout="row stretch" fxLayout.xs="column">
        <div [innerHTML]="message"></div>
    </div>

    <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin: 10px 0px;">

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Total a Saldar</b>: {{data?.Moneda}} {{data?.MontoTotal | number:'1.2-2'}}</mat-label>
                </div>
            </mat-expansion-panel>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: rgb(228, 186, 186);">
                <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Pendiente</b>: {{data?.Moneda}} {{montoPendiente | number:'1.2-2'}}</mat-label>
                </div>
            </mat-expansion-panel>
        </div>
    
    </div>
    
    <hr width="100%"  style="margin: 10px 0px;" />

    <form [formGroup]="formGroup">

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin: 10px 0px;">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isTipoMovimientoSearching">Tipo de Movimiento*</mat-label>
                    <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
                    <mat-select formControlName="TipoMovimientoId">
                        <mat-option *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!formGroup.controls['TipoMovimientoId'].valid && formGroup.controls['TipoMovimientoId'].touched">
                        {{ getErrorTipoMovimientoId() }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Importe*</mat-label>
                    <input matInput type="number" formControlName="Importe" (change)="calcularMontos()" (keyup.enter)="onAccept()">
                    <mat-error *ngIf="!formGroup.controls['Importe'].valid && formGroup.controls['Importe'].touched">
                        {{ getErrorImporte() }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Cantidad de Cuotas*</mat-label>
                    <input matInput type="number" formControlName="CantidadCuotas" (change)="calcularMontos()" (keyup.enter)="onAccept()">
                    <mat-error *ngIf="!formGroup.controls['CantidadCuotas'].valid && formGroup.controls['CantidadCuotas'].touched">
                        {{ getErrorCantidadCuotas() }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" >
                    <mat-label>{{(formGroup?.controls['CantidadCuotas']?.value > 1) ? 'Fecha de Inicio de Cuota' : 'Fecha Movimiento'}}*</mat-label>
                    <input matInput [matDatepicker]="fechaInicioCuotaPicker" formControlName="FechaInicioCuota"  (click)="fechaInicioCuotaPicker.open()">
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaInicioCuotaPicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #fechaInicioCuotaPicker></mat-datepicker>
                    <mat-error *ngIf="!formGroup.controls['FechaInicioCuota'].valid && formGroup.controls['FechaInicioCuota'].touched">
                        {{ getErrorFechaInicioCuota() }}
                    </mat-error>
                </mat-form-field>
            </div>

            <ng-container *ngIf="(formGroup?.controls['CantidadCuotas']?.value > 1)">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Periodicidad de Cuotas (en días)*</mat-label>
                        <input matInput type="number" formControlName="DiasRepeticionCuotas" (keyup.enter)="onAccept()">
                        <mat-error *ngIf="!formGroup.controls['DiasRepeticionCuotas'].valid && formGroup.controls['DiasRepeticionCuotas'].touched">
                            {{ getErrorDiasRepeticionCuotas() }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Porcentaje de Ajuste*</mat-label>
                        <input matInput type="number" formControlName="PorcentajeAjusteCuota" (change)="calcularMontos()" (keyup.enter)="onAccept()">
                        <mat-error *ngIf="!formGroup.controls['PorcentajeAjusteCuota'].valid && formGroup.controls['PorcentajeAjusteCuota'].touched">
                            {{ getErrorPorcentajeAjusteCuota() }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="(formGroup?.controls['PorcentajeAjusteCuota']?.value > 0)">
                    <mat-checkbox class="text-style" formControlName="AplicarAjusteIncremental" (keyup.enter)="onAccept()" color="primary">
                        Aplicar el porcentaje de ajuste <br/>de forma incremental en cada cuota
                    </mat-checkbox>
                </div>

            </ng-container>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-style"><b>Importe Primera Cuota</b>: {{data?.Moneda}} {{montoCuota | number:'1.2-2'}}</mat-label>
                    </div>
                </mat-expansion-panel>
            </div>

        </div>

        <!-- Seccion de deuda con pago asociado (solo aplica para deudas) -->
        <ng-container *ngIf="(signo < 0)">

            <hr width="100%"  style="margin: 10px 0px;" />

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin: 10px 0px;">

                <div fxFlex=33 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center" style="margin-top: 15px;">
                    <mat-checkbox class="text-style" formControlName="MovimientoPagado" (change)="onMovimientoPagadoChange()" (keyup.enter)="onAccept()" color="primary">
                        Tiene {{('MovimientoPago' | translate).toLowerCase()}} asociado
                    </mat-checkbox>
                </div>

                <ng-container *ngIf="(formGroup?.controls['MovimientoPagado']?.value == true)">

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                        <mat-form-field appearance="outline" style="width: 100%">
                            <mat-label *ngIf="!isTipoMovimientoSearching">Tipo de Movimiento del Pago*</mat-label>
                            <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
                            <mat-select formControlName="TipoMovimientoPagoId">
                                <mat-option *ngFor="let s of tipoMovimientoPagoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="(formGroup?.controls['MovimientoPagado']?.value == true)">
                        <mat-form-field appearance="outline" style="width: 100%">
                            <mat-label>Monto Pagado*</mat-label>
                            <input matInput type="number" formControlName="MontoPagado" (keyup.enter)="onAccept()">
                        </mat-form-field>
                    </div>

                </ng-container>

            </div>

            <hr width="100%"  style="margin: 10px 0px;" />

        </ng-container>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin: 5px 0px;">
            <button mat-raised-button color="primary" (click)="onSave()" class="zb-button">Guardar</button>
            <button mat-raised-button color="warn" (click)="onClean()" class="zb-button">Limpiar</button>
        </div>

        <hr width="100%" style="margin: 10px 0px;">

        <div fxLayout="row stretch" fxLayout.xs="column">

            <ejs-grid #grid [dataSource]='movimientoList' [allowPaging]="false" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
                [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                    <e-column field='FechaInicioCuota' headerText='Fecha' width=80 type="date" format="dd/MM/yyyy"></e-column>
                    <e-column field='TipoMovimiento' headerText='Tipo' width=90></e-column>
                    <e-column field='Importe' headerText='Importe' width=70 format="N2"></e-column>
                    <e-column field='CantidadCuotas' headerText='Cuotas' width=60></e-column>
                    <e-column field='DiasRepeticionCuotas' headerText='Periodicidad' width=50>
                        <ng-template #template let-data>
                            {{data.CantidadCuotas > 1 ? data.DiasRepeticionCuotas : '-'}}
                        </ng-template>
                    </e-column>
                    <e-column field='PorcentajeAjusteCuota' headerText='Ajuste' textAlign="right" width=50>
                        <ng-template #template let-data>
                            {{data.PorcentajeAjusteCuota | number:'1.2-2'}}%
                        </ng-template>
                    </e-column>
                    <e-column field='AplicarAjusteIncremental' headerText='Incremental?' width=50>
                        <ng-template #template let-data>
                            {{data.AplicarAjusteIncremental ? 'Sí' : 'No'}}
                        </ng-template>
                    </e-column>
                    <e-column headerText='Acciones' width=60>
                        <ng-template #template let-data>
                            <a style="cursor: pointer; margin-right: 5px" (click)="onEdit(data)" title="Editar movimiento">
                                <i class="fa fa-eye fa-1x"></i>
                            </a>
                            <a style="cursor: pointer; margin-right: 5px" (click)="onDelete(data)" title="Eliminar movimiento">
                                <i class="fa fa-trash fa-1x"></i>
                            </a>
                        </ng-template>
                    </e-column>
                </e-columns>
            </ejs-grid>

        </div>

    </form>

</div>

<br/>

<div mat-dialog-actions>
    <div fxLayout="row stretch" fxLayout.xs="column">
        <button mat-raised-button color="primary" (click)="onAccept()" class="zb-button">{{buttonAcceptText}}</button>
        <button mat-raised-button color="warn" (click)="onDecline()" class="zb-button">{{buttonCancelText}}</button>
    </div>
</div>
